// Action constants
import {SET} from './constants';

const DEFAULT_STATE = {
  loadingPaymentGroup: false,
  paymentGroup: null,
  drivers: [],
};

export default (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case SET: {
      return {
        ...state,
        ...data,
      };
    }

    default: {
      return state;
    }
  }
};
